import { createPlatePlugin } from 'platejs/react';

import { options } from 'common/components/ContentEditor/options';

const voidExitTypes = new Set([options.img.type, options.file.type]);

/** Always exit to a top-level sibling, regardless of nesting depth (list, blockquote, table). */
const matchRoot = (_node: unknown, path: number[]) => path.length === 1;

const isModEnter = (event: {
    key: string;
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
}) =>
    event.key === 'Enter' &&
    (event.metaKey || event.ctrlKey) &&
    !event.shiftKey;

const isModShiftEnter = (event: {
    key: string;
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
}) =>
    event.key === 'Enter' && (event.metaKey || event.ctrlKey) && event.shiftKey;

export const ExitBreakShortcutsPlugin = createPlatePlugin({
    key: 'exit-break-shortcuts',
    handlers: {
        onKeyDown: ({ editor, event }) => {
            if (isModEnter(event)) {
                event.preventDefault();
                editor.tf.insertExitBreak({ match: matchRoot });

                return true;
            }

            if (isModShiftEnter(event)) {
                const block = editor.api.block();

                if (block && voidExitTypes.has(block[0].type as string)) {
                    return false;
                }

                event.preventDefault();
                editor.tf.insertExitBreak({ match: matchRoot, reverse: true });

                return true;
            }

            return false;
        },
    },
});
